import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { StopCircle, Settings } from 'lucide-react';

interface EndNodeData {
  title?: string;
  color?: string;
  message?: string;
}

export const EndNode = memo(({ data, isConnectable }: NodeProps<EndNodeData>) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-gray-200 hover:border-gray-400 transition-colors duration-300">
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-gray-500"
      />
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <StopCircle className="h-4 w-4 mr-2" style={{ color: data.color || '#6B7280' }} />
          <div className="text-sm font-medium text-gray-900">
            {data.title || 'Finalizar'}
          </div>
        </div>
        <Settings className="h-4 w-4 text-gray-400" />
      </div>
      {data.message && (
        <div className="mt-2 text-sm text-gray-600">
          {data.message}
        </div>
      )}
    </div>
  );
});

EndNode.displayName = 'EndNode';